import { authenticatedFetch } from '../../../api/request';

export default async function getLanguages(setErrorMessage) {
    const onError = () => setErrorMessage('No se puede obtener los lenguajes.');
    return await authenticatedFetch('/language/getList', onError);
}
